export default __webpack_public_path__ + "static/media/rodrigo-calderon@2x.399d1694.png";